import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

import { initAuth, login } from './msal';
import App from './App';
import './styles.css';
// Wird für das schwebende Coach-Fenster gebraucht (die Styles werden dorthin kopiert)
import './overlay.css';

function Login() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const doLogin = async () => {
    setBusy(true);
    setError(null);
    try {
      await login();
    } catch (err) {
      setError(err && err.message ? err.message : String(err));
      setBusy(false);
    }
  };

  return (
    <div className="app centered">
      <div className="login-card">
        <div className="logo-dot" />
        <h1>Meeting Recorder</h1>
        <p>
          Melde dich mit deinem Microsoft-Konto an, um Termine zu erkennen und Aufnahmen zu
          verarbeiten.
        </p>
        <button className="btn primary block" onClick={doLogin} disabled={busy}>
          {busy ? 'Weiterleitung zur Anmeldung …' : 'Mit Microsoft anmelden'}
        </button>
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}

function Fatal({ message }) {
  return (
    <div className="app centered">
      <div className="login-card">
        <div className="logo-dot" />
        <h1>Meeting Recorder</h1>
        <p className="error">{message}</p>
      </div>
    </div>
  );
}

const root = createRoot(document.getElementById('root'));

// Erst die Anmeldung initialisieren (holt die Konfiguration vom Server und
// verarbeitet eine eventuelle Rückkehr von der Microsoft-Anmeldeseite),
// dann die Oberfläche zeigen.
initAuth()
  .then((msalInstance) => {
    root.render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthenticatedTemplate>
            <App />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Login />
          </UnauthenticatedTemplate>
        </MsalProvider>
      </StrictMode>
    );
  })
  .catch((err) => {
    root.render(<Fatal message={err && err.message ? err.message : String(err)} />);
  });
